import React, { useEffect, useState } from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useDispatch, useSelector } from 'react-redux'
import {
  Button,
  CircularProgress,
  Drawer,
  IconButton,
  Typography,
  useMediaQuery
} from '@material-ui/core'
import {
  Close as CloseIcon,
  FilterList as FilterListIcon,
  Search as SearchIcon
} from '@material-ui/icons'
import { SearchWidget } from 'pages/HomePage/components'
import { BannerSection, Footer, MainLayout, NavBar, PageContainer } from 'shared'
import { EventCard } from 'shared/EventCard'
import {
  loadSearchMetadata,
  search,
  setSearchParams as eventsSetSearchParams
} from 'state/modules/events'

import { FilterWidget } from '../FilterWidget'

import useStyles from './SearchPage.style'

const SEARCH_STATES = {
  SIMPLE_SEARCH: 'simpleSearch',
  MULTIPLE_SEARCH: 'multipleSearch'
}

const SearchPage = () => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const { user } = useSelector((state) => state.auth)
  const {
    searchParams: eventsSearchParams,
    searchEvents,
    searchEventsLastPage,
    pending,
    searchMetadata,
    searchMetadataPending
  } = useSelector((state) => state.events)
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('md'))

  const [filterDrawerOpen, setFilterDrawerOpen] = useState(false)
  const [showSearchPopupEl, setShowSearchPopupEl] = useState(null)

  const bannersPosition = isMobile ? 2 : 3

  useEffect(() => {
    dispatch(search(eventsSearchParams))
    dispatch(loadSearchMetadata(eventsSearchParams))
  }, [eventsSearchParams, dispatch, user])

  const doEventsSearch = (newSearchParams) => dispatch(eventsSetSearchParams(newSearchParams))

  return (
    <MainLayout>
      <NavBar
        widget={(props) => (
          <SearchWidget
            mini
            showSearchPopupEl={showSearchPopupEl}
            setShowSearchPopupEl={setShowSearchPopupEl}
            mode={SEARCH_STATES.MULTIPLE_SEARCH}
            {...props}
          />
        )}
        showWidget
      />
      <div className={classes.actionsContainer}>
        {!!eventsSearchParams.searchText && (
          <Typography
            color='primary'
            variant='h6'
            className={classes.text}
            title={`A continuación se muestran los resultados para la búsqueda: ${eventsSearchParams.searchText}`}>
            A continuación se muestran los resultados para la búsqueda:{' '}
            {eventsSearchParams.searchText}
          </Typography>
        )}
        <div className={classes.topActionsContainer}>
          <Button variant='text' color='primary' onClick={() => setFilterDrawerOpen(true)}>
            <span>Filtrar</span>
            <FilterListIcon />
          </Button>
          <IconButton color='primary' onClick={(e) => setShowSearchPopupEl(e.currentTarget)}>
            <SearchIcon />
          </IconButton>
        </div>
      </div>
      <PageContainer customContainerClassName={classes.container}>
        <div className={classes.filterContainer}>
          <div className={classes.filterWrapper}>
            <FilterWidget
              searchParams={eventsSearchParams}
              onSearchParamsChanged={doEventsSearch}
              searchMetadata={searchMetadata}
              searchMetadataPending={searchMetadataPending}
            />
          </div>
        </div>

        <div className={classes.resultsContainer}>
          {!!searchEvents.length && (
            <InfiniteScroll
              dataLength={searchEvents.length}
              hasMore={!searchEventsLastPage}
              next={() =>
                doEventsSearch({
                  ...eventsSearchParams,
                  page: eventsSearchParams.page + 1
                })
              }
              style={{ overflow: 'inherit' }}
              className={classes.listContainer}>
              {searchEvents.map((o, index) => (
                <>
                  {index === bannersPosition && (
                    <div className={classes.bannerContainer}>
                      <BannerSection />
                    </div>
                  )}
                  <div className={classes.cardContainer}>
                    <EventCard key={o.id} event={o} />
                  </div>
                </>
              ))}
            </InfiniteScroll>
          )}

          {pending && (
            <div className={classes.containerLoader}>
              <CircularProgress size={40} color='secondary' />
            </div>
          )}

          <div className={classes.endContainer}>
            {!pending && !searchEvents.length && (
              <div className={classes.messageContainer}>
                <Typography variant='h5' color='primary'>
                  No hay resultados cargados para la búsqueda que indicaste.
                </Typography>
                <Typography color='primary'>
                  Para obtener más resultados te recomendamos que modifiques los parámetros de
                  búsqueda.
                </Typography>
              </div>
            )}

            <div className={classes.buttonsContainer}>
              {!pending && !searchEventsLastPage && (
                <div className={classes.buttonContainer}>
                  <Button
                    color='primary'
                    variant='contained'
                    className={classes.button}
                    onClick={() => {
                      doEventsSearch({
                        ...eventsSearchParams,
                        page: eventsSearchParams.page + 1
                      })
                    }}>
                    Ver más
                  </Button>
                </div>
              )}
            </div>
          </div>
        </div>
      </PageContainer>
      {isMobile && (
        <Drawer
          ModalProps={{
            keepMounted: true
          }}
          open={filterDrawerOpen}
          onClose={() => setFilterDrawerOpen(false)}
          anchor='left'>
          <div className={classes.filterWrapper}>
            <div className={classes.filterDrawerHeader}>
              <IconButton color='primary' onClick={() => setFilterDrawerOpen(false)}>
                <CloseIcon className={classes.closeIcon} />
              </IconButton>
            </div>
            <FilterWidget
              searchParams={eventsSearchParams}
              onSearchParamsChanged={doEventsSearch}
              searchMetadata={searchMetadata}
              searchMetadataPending={searchMetadataPending}
            />
          </div>
        </Drawer>
      )}
      <Footer />
    </MainLayout>
  )
}

export default SearchPage
